export default __webpack_public_path__ + "static/design-contract-027e7ee56abce8873c29dcb84dc04709.gif";